var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-alert',{staticClass:"white--text mb-0",attrs:{"type":"warning","icon":"mdi-alert","rounded":"false","tile":""}},[_vm._v(" "+_vm._s(_vm.$t('pleaseNoteThatThisPageIsStillInABetaVersion'))+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }